import { useEffect, useMemo, useRef, useState } from "react";

import { PlotPlanMapping, usePlotPlanMappingApi } from "@/sx-layout/hooks/usePlotPlanMappingApi";

export const usePlotPlanClipImage = (plotPlanMapping: PlotPlanMapping) => {
  const plotPlanMappingApi = usePlotPlanMappingApi();

  const [clipImageBlob, setClipImageBlob] = useState<Blob>();
  const [loading, setLoading] = useState(false);

  const clipRef = useRef({ x: 0, y: 0, w: 0, h: 0 });
  useEffect(() => {
    if (
      plotPlanMapping.clip_x === clipRef.current.x &&
      plotPlanMapping.clip_y === clipRef.current.y &&
      plotPlanMapping.clip_w === clipRef.current.w &&
      plotPlanMapping.clip_h === clipRef.current.h
    ) {
      return;
    }

    clipRef.current = {
      x: plotPlanMapping.clip_x,
      y: plotPlanMapping.clip_y,
      w: plotPlanMapping.clip_w,
      h: plotPlanMapping.clip_h,
    };

    setLoading(true);
    plotPlanMappingApi
      .fetchPlotPlanMappingClipFile(plotPlanMapping.plot_plan_mapping_id)
      .then((blob) => {
        if (blob) {
          setClipImageBlob(blob);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [plotPlanMapping.timestamp]);

  const clipImageUrl = useMemo(() => {
    if (!clipImageBlob || !(clipImageBlob instanceof Blob)) return "";

    return URL.createObjectURL(clipImageBlob);
  }, [clipImageBlob]);

  // URLのメモリリークを防ぐためのクリーンアップ
  useEffect(() => {
    return () => {
      if (clipImageUrl) {
        URL.revokeObjectURL(clipImageUrl);
      }
    };
  }, [clipImageUrl]);

  return { clipImageUrl, loading };
};
